<div class="modal-header">
    <h6 class="modal-title">Admin : Study Unit : Add/ Edit Study Unit Practice Test</h6>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <!-- mock-exam-form.component.html -->
    <form [formGroup]="addEditForm">

      <div class="col-12" *ngIf="PracticeTest">
        <div class="row pt-1">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse">
              <div class="p-0 f-15">Test ID</div>
            </div>
          </div>
          <div class="col-12 col-lg-1 pl-2">
            <input
              type="text"
              id="practiceTestId"
              class="form-control form-control-sm"
              formControlName="practiceTestId"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row pt-1 align-items-center">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse">
              <div class="p-0 f-15">Subject</div>
            </div>
          </div>
          <div class="col-12 col-md-5 pl-2 d-flex align-items-center gap-2">
            <select
              id="subject"
              class="form-control form-control-sm"
              formControlName="subject"
              readonly
            >
              <option value="">Select Subject</option>
              <option *ngFor="let subject of subjects" [value]="subject.Code">
                {{ subject.Name }}
              </option>
            </select>
            <button
              type="button"
              class="btn btn-sm btn-success ms-2 d-flex gap-1 px-3"
              (click)="assignStudyUnit()"
            >
              <span>Select Study Unit</span>
            </button>
          </div>
        </div>

        <!-- Show selected study unit details below if available -->
        <div *ngIf="studyUnitName && studyUnitTopic">
          <div class="row pt-1 align-items-center">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 f-15">Topic Path</div>
              </div>
            </div>
            <div class="col-12 col-md-6 pl-2">
              <input
                type="text"
                class="form-control form-control-sm"
                [value]="studyUnitTopic"
                disabled
              />
            </div>
          </div>

          <div class="row pt-1 align-items-center">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 f-15">Selected Study Unit</div>
              </div>
            </div>
            <div class="col-12 col-md-6 pl-2">
              <input
                type="text"
                class="form-control form-control-sm"
                [value]="studyUnitName"
                disabled
              />
            </div>
          </div>
        </div>
      </div>




      <div class="col-12">
        <div class="row pt-1">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse">
              <div class="p-0 f-15">Status</div>
            </div>
          </div>
          <div class="col-12 col-lg-2 pl-2">
            <select
              id="status"
              class="form-control form-control-sm"
              formControlName="status"
            >
              <option value="">Select Status</option>
              <option *ngFor="let status of statuses" [value]="status.Code">
                {{ status.Description }}
              </option>
            </select>
            <small
              *ngIf="
                addEditForm.get('status')?.touched &&
                addEditForm.get('status')?.hasError('required')
              "
              style="color: red"
            >
              Field is required
            </small>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row pt-1">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse">
              <div class="p-0 f-15">No of Questions </div>
            </div>
          </div>
          <div class="col-12 col-md-4 pl-2">
            <input
              type="text"
              id="totalScore"
              class="form-control form-control-sm w-25 text-end"
              mask="separator.2"
              thousandSeparator=""
              separatorLimit="9999"
              formControlName="noOfQuestion"
            />
          </div>
        </div>
      </div>


      <div class="col-12">
        <div class="row pt-1">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse">
              <div class="p-0 f-15">Applicable Course Plan</div>
            </div>
          </div>
          <div class="col-12 col-md-4 pl-2">
            <div class="form-check" *ngFor="let course of courses">
              <input
                type="checkbox"
                class="form-check-input"
                [disabled]="disablecheckboxes(course.Code)"
                [id]="course.Code"
                [value]="course.Code"
                [checked]="checkedCoursePlan(course.Code)"
                (change)="onCourseChange($event)"
              />
              <label class="form-check-label f-15" [for]="course.Code">{{
                course.Description
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-sm bl-btn" (click)="onSubmit()">
      Save
    </button>
    <button
      type="button"
      class="btn btn-sm bg-light border"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
  </div>
